/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import { ixmUserauthV1ArtifactDownloadServiceDownloadArtifactBundle } from '@interxfi/api-client/generated/client-functions/ixm-userauth-v1-artifact-download-service-download-artifact-bundle';
import type { IxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundleRequest, IxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundleResponse, IxmUserauthV1JoinedRealmAccess } from '@interxfi/types';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { withAuthorizationToken } from '../../api-client';
import { useRealmAuthActiveAccess } from '../../context';
import { useRealmAPIContext } from '../../realm-context';

/**
 * @generated by NormalizedQueryPlugin (post /ixm/userauth/v1/artifact_download) */

export function buildIxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundleKey() { return ['/ixm.userauth.v1.ArtifactDownloadService/DownloadArtifactBundle'] as const; }

export function useIxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundle(options?: Partial<UseMutationOptions<IxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundleResponse | undefined, Error, IxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundleRequest, unknown>>, withAccess?: IxmUserauthV1JoinedRealmAccess) {
    const activeAccess = useRealmAuthActiveAccess();
    const { baseUrl, extendKey, token } = useRealmAPIContext(withAccess ?? activeAccess);
    
    return useMutation({
        mutationKey: extendKey(buildIxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundleKey()),
        mutationFn: async (request: IxmUserauthV1ArtifactDownloadServiceDownloadArtifactBundleRequest) => ixmUserauthV1ArtifactDownloadServiceDownloadArtifactBundle(baseUrl, request, withAuthorizationToken(token)),
        ...options
    });
}
